import { env } from '../services/commonService.js';

export const authConfig = {
  backendBaseUrl: env().baseUrl,
  authUrl: env().authUrl,
  appClientId: env().cId,
  audience: env().audience,
  scope: env().scope,
};
